module.exports = __webpack_public_path__ + "static/zeami-80c466122f673cd60a946f940858a408.png";